export const DIGIT_REGEX = /^(?=.*?[0-9])/;
export const UPPER_REGEX = /^(?=.*?[A-Z])/;
export const LOWER_REGEX = /^(?=.*?[a-z])/;
